import { render } from "./RoleCreateEditDialog.vue?vue&type=template&id=0f14a928&scoped=true&ts=true"
import script from "./RoleCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./RoleCreateEditDialog.vue?vue&type=script&lang=ts"

import "./RoleCreateEditDialog.vue?vue&type=style&index=0&id=0f14a928&scoped=true&lang=css"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f14a928"]])

export default __exports__